import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ListingCard } from "@/components/ListingCard";
import { Reveal, staggerParent, staggerChild } from "@/components/Motion";
import { ArrowRight, Route } from "lucide-react";

function Empty() {
  return (
    <Reveal className="mt-10 rounded-3xl border border-dashed border-navy/20 bg-white/60 p-10 sm:p-16 text-center" data-testid="latest-empty">
      <Route className="w-10 h-10 text-teal mx-auto" />
      <h3 className="font-heading font-extrabold text-navy text-2xl sm:text-3xl tracking-tight mt-5">The road starts here.</h3>
      <p className="text-slatev mt-2">Vorra is ready for its first sellers.</p>
      <Link to="/sell" data-testid="latest-empty-sell" className="mt-7 inline-flex items-center gap-2 h-12 px-7 rounded-full bg-teal hover:bg-teal-dark text-white font-semibold transition-[transform,background-color] hover:-translate-y-0.5">
        Sell my car <ArrowRight className="w-4 h-4" />
      </Link>
    </Reveal>
  );
}

export function LatestListings({ items, loaded }) {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-24 lg:pt-32" data-testid="latest-listings">
      <div className="flex items-end justify-between gap-4">
        <Reveal><span className="text-xs uppercase tracking-widest font-semibold text-teal">Just listed</span>
          <h2 className="font-heading font-extrabold text-navy tracking-tighter text-3xl sm:text-4xl mt-2">Latest listings</h2></Reveal>
        {items.length > 0 && <Link to="/browse" data-testid="view-all-btn" className="text-sm font-semibold text-navy hover:text-teal inline-flex items-center gap-1 transition-colors">View all <ArrowRight className="w-4 h-4" /></Link>}
      </div>
      {loaded && items.length === 0 ? <Empty /> : (
        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
          className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((l) => <motion.div key={l.id} variants={staggerChild}><ListingCard listing={l} /></motion.div>)}
        </motion.div>
      )}
    </section>
  );
}
